import { of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { OnScreenResultsFilterDefenitions } from '../../on-screen-results/standard-test-results/on-screen-results-filter-defenitions';
import { FilterFieldValue, FilterFieldDef } from '../../covance-filter';

@Injectable()
export class LabResultsFilterStorage {

    public readonly siteDataFilterFields: Observable<FilterFieldValue[]>;
    public readonly trendsFilterFields: Observable<FilterFieldValue[]>;
    public readonly subjectFilter: Observable<FilterFieldValue>;

    constructor(
        private onScreenResultsFilterDefenitions: OnScreenResultsFilterDefenitions
    ) {
        this.trendsFilterFields = this.getFilterDef(this.onScreenResultsFilterDefenitions.trendsFilterFieldDefs).pipe(publishReplay(1), refCount());
        this.siteDataFilterFields = this.getFilterDef(this.onScreenResultsFilterDefenitions.siteDataFilterFieldDefs).pipe(publishReplay(1), refCount());
        this.subjectFilter = this.trendsFilterFields.pipe(map(filters => filters.find(f => f.def.title === 'Subject')));
    }

    private getFilterDef(filters: FilterFieldDef[]) {
        return of(filters.map(def => { return { def: def } as FilterFieldValue; }));
    }
}